import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { preloadImages } from '../../utils';

const featuresGrid = document.querySelector('.js-features-masonary');
const featuresMediaContainer = document.querySelector('.js-features-media-container');
const featuresMedia = document.querySelector('.js-features-media');

const init = () => {
    if (!featuresGrid) return;

    switch (featuresMedia.tagName) {
        case 'VIDEO':
            setTimeout(() => {
                featuresMediaContainer.classList.remove('is-loading');
            }, 500);
            break;

        case 'IMG':
            preloadImages('.js-features-media-container').then(() => {
                featuresMediaContainer.classList.remove('is-loading');
            });
            break;

        default:
    }

    const masonary = new Masonry(featuresGrid, {
        itemSelector: '.js-features-masonary-item',
        columnWidth: '.js-features-masonary-sizer',
        percentPosition: true,
        gutter: 30,
    });

    imagesLoaded(featuresGrid).on('progress', () => {
        masonary.layout();
    });
};

export default init;
